module.exports = __webpack_public_path__ + "static/media/tooltip.66c790dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tooltip.svg
// module id = 2799
// module chunks = 3